
import { Component, Prop, Emit, Watch, Mixins } from 'vue-property-decorator';
import SiteLogo from '@/components/SiteLogo.vue';
import LatestMenu from '@/mixins/LatestMenu';
import store from '@/store';

@Component({
  components: {
    SiteLogo,
  },
})
export default class FloatBottom extends Mixins(LatestMenu) {
  private name = 'floatBottom';
  private spMenuFlg: boolean = false;
  
  @Emit()
  private openSpMenu(): void {
    this.spMenuFlg = true;
  }

  @Emit()
  private closeSpMenu(): void {
    this.spMenuFlg = false;
  }

  @Emit()
  private openModalSearchNavi(): void {
    store.commit('searchmodal/open', 'ModalSearchnavi');
  }


  @Watch('$route', { immediate: true, deep: true })
  private onUrlChange(newVal: any) {
    this.closeSpMenu();
  }
}
